/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, Output, EventEmitter, ElementRef, Renderer, HostBinding, ViewEncapsulation } from '@angular/core';
// import { animate, state, style, transition, trigger, keyframes } from '@angular/animations';

import classNames from 'classnames';
import { transitionLeave } from '../animation/transition';
export class Tag {
/**
 * 样式前缀
 */
prefixCls = 'ant-tag';
/**
 * 标签是否可以关闭
 */
closable = false;
/**
 * 标签色
 */
color: string;
/**
 * 用户CSS样式
 */
class: string;
/**
 * 关闭前事件
 */
beforeClose = new EventEmitter<Event>();
/**
 * 关闭后事件
 */
close = new EventEmitter<Event>();
/**
 * 状态
 */
public closed = false;
/**
 * @param {?} renderer
 * @param {?} elementRef
 */
constructor(private renderer: Renderer,
private elementRef: ElementRef) {

    }
/**
 * @return {?}
 */
get classes(): string {
        const /** @type {?} */ isPresetColor = this.isPresetColor(this.color);
        const /** @type {?} */ classString = classNames(this.prefixCls, {
            [`${this.prefixCls}-${this.color}`]: isPresetColor,
            [`${this.prefixCls}-has-color`]: (this.color && !isPresetColor)
        }, this.class);

        return classString;
    }
/**
 * @return {?}
 */
get backgroundColor(): string {
        const /** @type {?} */ isPresetColor = this.isPresetColor(this.color);
        return (this.color && !isPresetColor) ? this.color : null;
    }
/**
 * @return {?}
 */
get dataShow(): boolean {
        return !this.closed;
    }
/**
 * @return {?}
 */
get textClass(): string {
        return `${this.prefixCls}-text`;
    }
/**
 * @return {?}
 */
get transitionName(): string {
        return `${this.prefixCls}-zoom`;
    }
/**
 * The underlying host native element
 * @return {?}
 */
getHostElement(): HTMLElement {
        return /** @type {?} */(( this.elementRef.nativeElement as HTMLElement));
    }
/**
 * @param {?} event
 * @return {?}
 */
doClose(event: Event): void {
        this.beforeClose.emit(event);
        if (event.defaultPrevented) {
            return;
        }

        const /** @type {?} */ dom = this.getHostElement();
        dom.style.width = `${dom.getBoundingClientRect().width}px`;
        // It's Magic Code, don't know why
        dom.style.width = `${dom.getBoundingClientRect().width}px`;

        // 执行动画
        transitionLeave(dom, this.transitionName, () => {
            this.closed = true;
            this.close.emit(event);
            this.elementRef.nativeElement.remove(); // remove from dom tree
        });
    }
/**
 * @param {?} color
 * @return {?}
 */
isPresetColor(color: string): boolean {
        return /^(pink|red|yellow|orange|cyan|green|blue|purple)(-inverse)?$/.test(color);
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-tag',
    template: `
        <span [class]="textClass"><ng-content></ng-content></span>
        <ant-icon type="cross" (click)="doClose($event)" *ngIf="closable"></ant-icon>
    `,
    styleUrls: ['./style/index.scss'],
    encapsulation: ViewEncapsulation.None,
    /*
    animations: [
        trigger('state', [
            state('closed', style({ opacity: 0 })),
            transition('* => closed', [animate('300ms ease-out', keyframes([
                style({ transform: 'scale(1)', opacity: 1, offset: 0 }),
                style({ transform: 'scale(0.2)', opacity: 0, offset: 1 })
            ]))])
        ])
    ]*/
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'closable': [{ type: Input },],
'color': [{ type: Input },],
'class': [{ type: Input },],
'beforeClose': [{ type: Output },],
'close': [{ type: Output },],
'classes': [{ type: HostBinding, args: ['class', ] },],
'backgroundColor': [{ type: HostBinding, args: ['style.backgroundColor', ] },],
'dataShow': [{ type: HostBinding, args: ['attr.data-show', ] },],
};
}

function Tag_tsickle_Closure_declarations() {
/** @type {?} */
Tag.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Tag.ctorParameters;
/** @type {?} */
Tag.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
Tag.prototype.prefixCls;
/**
 * 标签是否可以关闭
 * @type {?}
 */
Tag.prototype.closable;
/**
 * 标签色
 * @type {?}
 */
Tag.prototype.color;
/**
 * 用户CSS样式
 * @type {?}
 */
Tag.prototype.class;
/**
 * 关闭前事件
 * @type {?}
 */
Tag.prototype.beforeClose;
/**
 * 关闭后事件
 * @type {?}
 */
Tag.prototype.close;
/**
 * 状态
 * @type {?}
 */
Tag.prototype.closed;
/** @type {?} */
Tag.prototype.renderer;
/** @type {?} */
Tag.prototype.elementRef;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
